import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import SubNavigation from "./SubNavigation";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

function SettingsTabs(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	const tabs = [{
		label: "General",
		value: "general",
		hasAccess: true
	},{
		label: "Team",
		value: "team",
		hasAccess: AuthorizedUser.hasTeam(authenticatedUser)
	},{
		label: "Locations",
		value: "locations",
		hasAccess: AuthorizedUser.hasLocations(authenticatedUser)
	},{
		label: "Sources",
		value: "sources",
		hasAccess: AuthorizedUser.isAdmin(authenticatedUser) && authenticatedUser.isFreemium
	}];

	let {tabClicked, selectedTab, setBannerClassName, hasNudgeBanner, isEdit} = props;

	return (
		<SubNavigation
			tabs={tabs}
			title="Settings"
			isEdit={isEdit}
			selectedTab={selectedTab}
			tabClicked={tabClicked}
			hasNudgeBanner={hasNudgeBanner}
			setBannerClassName={setBannerClassName} />
	);
}

SettingsTabs.propTypes = {
	hasNudgeBanner: PropTypes.bool,
	tabClicked: PropTypes.func.isRequired,
	setBannerClassName: PropTypes.func.isRequired,
	selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
	isEdit: PropTypes.bool
};

export default SettingsTabs;